export default [
  {
    path: 'data/tasks',
    name: 'Tasks',
    component: () => import('./views/Tasks.vue'),
    props: route => ({ datasetId: route.query.dataset })
  },
  {
    path: 'data/tasks/:id',
    name: 'TaskDetail',
    component: () => import('./views/TaskDetail.vue'),
  }
];